import React, { useContext } from 'react';

interface DepartmentContext {
  openDepartment: number | null | undefined;
  setOpenDepartment: (departmentId: number | undefined) => void;
}

const departmentContext = React.createContext<DepartmentContext>(
  null as unknown as DepartmentContext
);

export const DepartmentContextProvider = departmentContext.Provider;
export const DepartmentContextConsumer = departmentContext.Consumer;

export const useDepartmentContext = () => {
  const context = useContext(departmentContext);
  return context;
};
